import axios from '../axios';

// Actions
export const LOAD_VEHICLE_TYPE_LIST_SUCCESS = 'LOAD_VEHICLE_TYPE_LIST_SUCCESS';
export const LOAD_VEHICLE_TYPE_LIST_FAILED = 'LOAD_VEHICLE_TYPE_LIST_FAILED';

// Reducer
export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case LOAD_VEHICLE_TYPE_LIST_SUCCESS:
      return {
        ...state,
        all: action.data,
        error: '',
      };
    case LOAD_VEHICLE_TYPE_LIST_FAILED:
      return {
        ...state,
        error: action.error,
      };
    default:
      return state;
  }
}

// Action Creators
export const loadVehicleTypeListSuccess = (data) => {
  return {
    type: LOAD_VEHICLE_TYPE_LIST_SUCCESS,
    data,
  };
};
export const loadVehicleTypeListFailed = (error) => {
  return {
    type: LOAD_VEHICLE_TYPE_LIST_FAILED,
    error,
  };
};

export const loadVehicleTypeList = () => {
  return (dispatch) => {
    axios
      .get('/vehicle-types', { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } })
      .then((response) => {
        dispatch(loadVehicleTypeListSuccess(response.data.filter((e) => e.isActive)));
      })
      .catch((error) => {
        dispatch(loadVehicleTypeListFailed(error));
      });
  };
};
